import { WIZARD_DOMAIN } from './util/config';

export const WebRoutes = {
  jobApplicationRoute: (jobHash: ?string) => `/apply/${jobHash || ':jobHash'}/:version?`,
  jobApplicationRouteVersioned: (jobHash: ?string, version: ?string) => `/apply/${jobHash || ':jobHash'}/v/${version || ':version'}`,
  jobApplicationRouteUnversioned: (jobHash: ?string) => `/apply/${jobHash || ':jobHash'}`,
  referralApplyRoute: (jobHash: ?string, referralHash: ?string) => `/apply/${jobHash || ':jobHash'}/referral/${referralHash || ':referralHash'}`,
  wizardStart: (jobApplicationHash: string) => `${WIZARD_DOMAIN}/wizard/${jobApplicationHash || ':jobApplicationHash'}/start`,
};
